import { makeStyles, Typography } from '@material-ui/core';
import React, { ReactNode } from 'react';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  label: {
    fontWeight: 600,
    marginRight: '0.75rem',
  },
}));

interface Props {
  label: ReactNode;
  content: ReactNode;
  separator?: string;
}

export const LabeledField = ({ label, content, separator = ':' }: Props) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Typography component="span" className={styles.label}>
        {label}
        {separator}
      </Typography>
      <Typography component="span">{content}</Typography>
    </div>
  );
};
